import styles from './styles.module.scss';

/** Full maple-leaf path from src/assets/icons/maple-leaf.svg (the PNG strip was cropped). */
const LEAF_PATH =
  'M1212.3,642.7l-54.9-27.1c-10.4-5.2-15.6-17.1-12.3-28.3l46.7-154.8c1.9-6.4-3.5-12.5-10.1-11.4l-127.8,21.7c-10.2,1.7-20.4-3.3-25.2-12.5l-43.1-82.8c-2.8-5.3-9.8-6.5-14.2-2.3l-134.2,129.4c-17.2,16.5-45.3.5-39.8-22.7l69.7-292.2c1.7-7.1-5.4-13.2-12.2-10.3l-112.2,46.9c-11.3,4.7-24.4.1-30.2-10.7L614.9,3.7c-2.7-4.9-9.7-4.9-12.4,0l-97.8,181.7c-5.8,10.8-18.9,15.4-30.2,10.7l-112.2-46.9c-6.8-2.8-13.9,3.2-12.2,10.3l69.7,292.2c5.5,23.2-22.6,39.3-39.8,22.7l-134.2-129.4c-4.3-4.2-11.4-3-14.2,2.3l-43.1,82.8c-4.8,9.2-14.9,14.2-25.2,12.5l-127.8-21.7c-6.5-1.1-12,5-10.1,11.4l46.7,154.8c3.4,11.2-1.8,23.1-12.3,28.3l-54.9,27.1c-5.8,2.9-6.7,10.9-1.7,15l293.7,238.9c8.2,6.7,11.1,18.1,6.9,27.9l-34.8,81.7c-2.8,6.7,3.1,13.8,10.2,12.2l309.8-68.4c1.7-.4,3.3,1,3.2,2.7l-15.8,307.7c-.1,2.5,1.9,4.6,4.4,4.6h55.6c2.5,0,4.5-2.1,4.4-4.6l-15.8-307.7c0-1.7,1.5-3.1,3.2-2.7l309.8,68.4c7.1,1.6,13-5.5,10.2-12.2l-34.8-81.7c-4.2-9.8-1.3-21.1,6.9-27.9l293.7-238.9c5.1-4.1,4.2-12.1-1.7-15Z';

const COLORS = ['#F0441C', '#EBC54B', '#F0441C', '#EBC54B', '#F0441C'] as const;

export const VacLeafRow = () => (
  <div className={styles.row} aria-hidden="true">
    {COLORS.map((fill, index) => (
      <svg
        key={index}
        className={styles.leaf}
        viewBox="-40 -40 1297.3 1345"
        focusable="false"
      >
        <path fill={fill} d={LEAF_PATH} />
      </svg>
    ))}
  </div>
);
